import React, { createContext, useContext, useEffect, useState } from "react";

const I18nCtx = createContext();

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("altamira_lang") || "es");
  useEffect(() => {
    localStorage.setItem("altamira_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (obj) => (obj && typeof obj === "object" ? obj[lang] || obj.es : obj);
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  return useContext(I18nCtx);
}

export const STR = {
  nav: {
    home: { es: "Inicio", en: "Home" },
    company: { es: "Empresa", en: "Company" },
    catalog: { es: "Catálogo", en: "Catalog" },
    services: { es: "Servicios", en: "Services" },
    blog: { es: "Blog", en: "Blog" },
    contact: { es: "Contacto", en: "Contact" },
  },
  cta: {
    quote: { es: "Solicitar cotización", en: "Request a quote" },
    whatsapp: { es: "Escribir por WhatsApp", en: "Message us on WhatsApp" },
    viewMore: { es: "Ver más", en: "See more" },
    viewCatalog: { es: "Ver catálogo", en: "View catalog" },
    readMore: { es: "Leer más", en: "Read more" },
  },
};
